export default {
    state: {
        list: null,
        listIntegrationsAccessExecution: null,
        integrationData: {
            name: undefined,
            integrationType: undefined
        }
    },

    mutations: {
        INTEGRATION_SET_LIST(state, list) {
            state.list = list;
        },
        SET_INTEGRATION_DATA(state, data) {
            state.integrationData = data;
        },
        INTEGRATION_ACCESS_EXECUTION_SET_LIST(state, data) {
            state.listIntegrationsAccessExecution = data;
        }
    }
};
